exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".quotePMargin[data-v-0a793f33]{margin:0;text-align:left!important}.md-direction-bottom-right[data-v-0a793f33]{width:18%!important}.md-flex-xsmall-100[data-v-0a793f33]{min-width:100%;flex:0 1 100%}.center[data-v-0a793f33]{text-align:center}.b-form-input-container[data-v-0a793f33]{margin:4px 0 12px!important}.activeClass[data-v-0a793f33]{display:none}.error[data-v-0a793f33]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a793f33","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/Pricing/upsertEnqPrice.vue
// module id = 1373
// module chunks = 0